import React from 'react';
import { useSelector } from 'react-redux';

import { getUserGroups } from '@actions/selectors';
import H5 from '@styled/Elements/H5';

import Description from '../components/Description';
import Section from '../components/Section';
import GroupBadge from './GroupBadge';
import Groups from './Groups';
import GroupsLabel from './GroupsLabel';

export default function PersonalInfo() {
  const userFullName = useSelector((state) => { return state.auth.user?.username});
  const groups = useSelector(getUserGroups);

  return (
    <Section>
      <Description>
        <H5>Account</H5>
      </Description>
      <div>
        <div>{userFullName}</div>
        {groups.length > 0 && (
          <>
            <GroupsLabel>User Groups</GroupsLabel>
            <Groups>
            {groups.map(group => (
              <GroupBadge key={group}>{group}</GroupBadge>
            ))}
            </Groups>
          </>
        )}
      </div>
    </Section>
  );
}
